// built-in imports
import { motion } from "framer-motion";

// Internal imports
import { Wrapper } from "./skills-category.styles";
import SkillCard from "../skill-card/skill-card.component";
import { useAppContext } from "../../layout/layout";
import { textVariant } from "../../utils/motion/motion.utils";
import sectionWrapper from "../../hoc/sction-wrapper.component";

const SkillsCategory = ({ skills, en_title, de_title, index }) => {
  const { lang } = useAppContext();
  return (
    <Wrapper>
      <motion.h4 variants={textVariant(index / 3)}>
        {lang === "en" ? en_title : de_title}
      </motion.h4>
      <motion.div
        transition={{
          type: "stween",
          when: "beforeChildren",
          staggerChildren: 0.2,
        }}
        className="skills-category-container"
      >
        {!!skills &&
          skills.map((skill) => <SkillCard key={skill.name} {...skill} />)}
      </motion.div>
    </Wrapper>
  );
};
export default sectionWrapper(SkillsCategory);
